import { render, staticRenderFns } from "./LsNewProperty.vue?vue&type=template&id=1a67aefb&scoped=true&"
import script from "./LsNewProperty.vue?vue&type=script&lang=js&"
export * from "./LsNewProperty.vue?vue&type=script&lang=js&"
import style0 from "./LsNewProperty.vue?vue&type=style&index=0&id=1a67aefb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67aefb",
  null
  
)

export default component.exports